import { ApplicationTheme } from "@multiweb/uiShared/ApplicationTheme";
import { SET_THEME, TOGGLE_THEME } from "./constants";
import { ISetThemeAction, IToggleThemeAction } from "./types";

/**
 * Akce pro přepnutí tématu aplikace.
 */
export const createToggleThemeAction = (): IToggleThemeAction => ({
    type: TOGGLE_THEME,
});

/**
 * Akce pro nastavení tématu aplikace.
 * @param theme Název tématu které se má nastavit.
 */
export const createSetThemeAction = (theme: ApplicationTheme): ISetThemeAction => ({
    type: SET_THEME,
    payload: {
        theme,
    },
});
